<template>
    <div class="file-wrapper-modify">
        <div class="file-wrapper-modify__controller">
            <span v-if="list?.length === 1" class="file-wrapper-modify__controller__label">
                {{ $t(`fileWrapperMultiView.${currentSelectModifyFile.type}Amendment`, {
                    mrdt: currentSelectModifyFile.mrdt
                }) }}
            </span>
            <Dropdown
                v-else
                class="file-wrapper-modify__controller__dropdown"
                trigger="click"
                @visible-change="(val) => isShowDropDown = val"
                @command="onSelect"
            >
                <div class="file-wrapper-modify__controller__dropdown__btn">
                    <span>{{ $t(`fileWrapperMultiView.${currentSelectModifyFile.type}Amendment`, {
                        mrdt: currentSelectModifyFile.mrdt,
                    }) }}</span>
                    <PtIcon
                        :icon="isShowDropDown ? 'SolidDropdownClose' : 'SolidDropdownOpen'"
                    />
                </div>
                <DropdownMenu slot="dropdown">
                    <DropdownItem
                        v-for="(item, index) in list"
                        :key="`${item.mrdt}__${index}`"
                        :command="item"
                    >
                        {{ $t(`fileWrapperMultiView.${item.type}Amendment`, {
                            mrdt: item.mrdt,
                        }) }}
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>

            <div v-if="hasSwitch" class="file-wrapper-modify__controller__switch">
                <span
                    :class="{
                        'file-wrapper-modify__controller__switch__item': true,
                        'active': showPdfFile
                    }"
                    @click="modifyFileType = 'pdf'"
                >PDF</span>
                <span
                    :class="{
                        'file-wrapper-modify__controller__switch__item': true,
                        'active': showTextFile
                    }"
                    @click="modifyFileType = 'text'"
                >{{ $t('fileWrapperMultiView.text') }}</span>
            </div>
        </div>
        <div v-if="nodata" class="file-wrapper-modify__nodata">
            <PtNodata :nodata-tips="$t('fileWrapperMultiView.amendmentsDisabled')" />
        </div>
        <div v-else class="file-wrapper-modify__content">
            <div v-if="showTextFile" class="file-wrapper-modify__text">
                <div v-if="showTextFile" class="file-wrapper-modify__tips">
                    <span
                        v-html="$t('fileWrapperMultiView.modifyFileTips', {
                            modifyType: $t(`fileWrapperMultiView.${ round === 1 ? 'firstPublic' : 'lastAmendment'}`)
                        })"
                    />
                </div>
                <div class="file-wrapper-modify__text__container" v-html="currentSelectModifyFile.text" />
            </div>
            <FileWrapperMultiViewPdf
                v-else-if="showPdfFile"
                class="file-wrapper-modify__pdf"
                :pdf="currentSelectModifyFile.pdf"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, defineProps, watch, computed, defineEmits } from 'vue';
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui';
import FileWrapperMultiViewPdf from './FileWrapperMultiViewPdf.vue';
import _ from 'lodash';
import PtNodata from '../PtNodata';
import { Icon as PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/DropdownClose.svg';
import '@patsnap-ui/icon/assets/solid/DropdownOpen.svg';

const isShowDropDown = ref(false);

const props = defineProps({
    list: {
        type: Array,
        default: () => [],
    },
    round: {
        type: Number,
        default: 1,
    },
    mrdt: {
        type: String,
        default: '',
    },
});
const emits = defineEmits(['onChange']);

const currentSelectModifyFile = ref(_.get(props.list, 0));

const onSelect = (item) => {
    currentSelectModifyFile.value = item;
};

const hasSwitch = ref(false);
const modifyFileType = ref('text');
const nodata = ref(false);

watch(currentSelectModifyFile, () => {
    hasSwitch.value = false;
    nodata.value = false;
    if (currentSelectModifyFile.value.pdf && currentSelectModifyFile.value.text) {
        hasSwitch.value = true;
        // modifyFileType.value = 'text';
    } else if (!currentSelectModifyFile.value.pdf && !currentSelectModifyFile.value.text) {
        nodata.value = true;
    } else {
        modifyFileType.value = currentSelectModifyFile.value.text ? 'text' : 'pdf';
    }
}, { immediate: true });

const showTextFile = computed(() => {
    return modifyFileType.value === 'text';
});

const showPdfFile = computed(() => {
    return modifyFileType.value === 'pdf';
});

const modifyFileTips = computed(() => {
    return modifyFileTips;
});

watch(currentSelectModifyFile, () => {
    const mrdt = _.get(currentSelectModifyFile.value, 'mrdt');
    emits('onChange', mrdt);
}, { immediate: true });

// 获取默认选中
watch(() => props.mrdt, (val) => {
    const item = _.find(props.list, { mrdt: val });
    if (item) {
        currentSelectModifyFile.value = item;
    } else {
        currentSelectModifyFile.value = _.head(props.list);
    }
}, { immediate: true });

</script>

<style lang="scss">
.file-wrapper-modify {
    padding: 4px 16px 16px 16px;
    display: flex;
    flex-direction: column;
    .file-wrapper-modify__controller {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;

        .file-wrapper-modify__controller__label {
            line-height: 24px;
            font-weight: 600;
            padding: 2px 4px;
        }
        .file-wrapper-modify__controller__dropdown {
            .file-wrapper-modify__controller__dropdown__btn {
                line-height: 24px;
                border-radius: 4px;
                color: $text-primary;
                font-weight: 600;
                padding: 2px 4px;
                cursor: pointer;
                outline: none;
                display: flex;
                align-items: center;

                &:hover {
                    background-color: $bg-dark;
                }
            }
        }

        .file-wrapper-modify__controller__switch {
            background: $bg-dark;
            border-radius: 5px;
            padding: 2px;
            line-height: 20px;

            .file-wrapper-modify__controller__switch__item {
                font-size: 12px;
                padding: 0 8px;
                border-radius: 4px;
                display: inline-block;
                cursor: pointer;

                &:hover {
                    background: $bg-hover;
                }

                &.active {
                    background: #fff;
                }
            }
        }
    }

    .file-wrapper-modify__content {
        margin-top: 8px;
        flex: 1;
        .file-wrapper-modify__text {
            .file-wrapper-modify__tips {
                font-size: 12px;
                line-height: 16px;
                color: $text-hint;

                .tips-remove {
                    color: $status-red-primary;
                    text-decoration: line-through;
                }
                .tips-add {
                    color: $green-text;
                }
            }
            .file-wrapper-modify__text__container {
                line-height: 24px;
                margin-top: 8px;
                // 让文本中的\n换行
                white-space: pre-line;
                .ins {
                    color: $green-text;
                }
                .del {
                    color: $status-red-primary;
                    text-decoration: line-through;
                }
                .status {
                    display: inline-block;
                    padding: 2px 8px;
                    line-height: 16px;
                    background: $bg-dark;
                    border-radius: 4px;
                    margin: 0 2px;
                }
            }
        }
    }

    .file-wrapper-modify__nodata {
        margin-top: 32px;
        .pt_nodata .pt_nodata-title {
            color: $text-hint;
            font-size: 14px;
        }
    }
}
</style>
